export interface AIPromptOptions {
  id: string;
  name: string;
  displayName: string;
  description: string;
  explainer: string;
  targetClassname: string;
  isPublished: boolean;
  publishedAt: string;
  createdAt: string;
  updatedAt: string;
}

function getDefaults(): AIPromptOptions {
  return {
    id: '',
    name: '',
    displayName: '',
    description: '',
    explainer: '',
    targetClassname: '',
    isPublished: false,
    publishedAt: '',
    createdAt: '',
    updatedAt: '',
  };
}

export default class AIPrompt {
  id: string;
  name: string;
  displayName: string;
  description: string;
  explainer: string;
  targetClassname: string;
  isPublished: boolean;
  publishedAt: string;
  createdAt: string;
  updatedAt: string;

  constructor(options: Partial<AIPromptOptions>) {
    const opts = { ...getDefaults(), ...options };

    this.id = opts.id;
    this.name = opts.name;
    this.displayName = opts.displayName;
    this.description = opts.description;
    this.explainer = opts.explainer;
    this.targetClassname = opts.targetClassname;
    this.isPublished = opts.isPublished;
    this.publishedAt = opts.publishedAt;
    this.createdAt = opts.createdAt;
    this.updatedAt = opts.updatedAt;
  }
}
